'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactGoogleRecaptcha = require('react-google-recaptcha');

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _modal_type = require('redux/actions/modal_type');

var _registration = require('redux/actions/registration');

var _pass_recovery = require('redux/actions/pass_recovery');

var _BaseForm2 = require('components/BaseForm');

var _BaseForm3 = _interopRequireDefault(_BaseForm2);

var _helpers = require('helpers');

var _Validators = require('../Validators');

var Validators = _interopRequireWildcard(_Validators);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RegistrationForm = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        errorsList: state.registration.errorsList,
        errorCode: state.registration.errorCode,
        lang: state.lang,
        preload: state.registration.preload,
        setting: state.setting,
        shopId: state.setting.shopId,
        googleCaptcha: state.setting.googleCaptcha,
        googleCaptchaSitekey: state.setting.googleCaptchaSitekey
    };
}, { showModalAuth: _modal_type.showModalAuth, registration: _registration.registration, resetError: _registration.resetError, showModalPassRecovery: _modal_type.showModalPassRecovery, sendPhoneToReducer: _pass_recovery.sendPhoneToReducer, resetStep: _pass_recovery.resetStep }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
    (0, _inherits3.default)(RegistrationForm, _BaseForm);

    function RegistrationForm(props, context) {
        (0, _classCallCheck3.default)(this, RegistrationForm);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RegistrationForm.__proto__ || (0, _getPrototypeOf2.default)(RegistrationForm)).call(this, props, context));

        _this.checkInn = function (typeAdditionalField) {
            var REGEX_INN = /^[\d]+$/igm;

            return _this.state[typeAdditionalField.slug] && REGEX_INN.test(_this.state[typeAdditionalField.slug]) && (_this.state[typeAdditionalField.slug].length === 10 || _this.state[typeAdditionalField.slug].length === 12);
        };

        _this.checkCustomField = function () {
            var setting = _this.props.setting;


            if (setting.additionalFieldSettings) {
                // если есть в настройках магазина настройки для полей
                // достаем все обязательные поля
                var requiredField = setting.additionalFieldSettings.filter(function (item) {
                    return item.required_in_registration;
                });

                var flag = void 0;

                requiredField.forEach(function (item) {
                    var typeAdditionalField = item.typeAdditionalField;


                    if (typeAdditionalField.slug === 'inn') {
                        if (!flag && !_this.checkInn(typeAdditionalField)) {
                            flag = true;
                        }
                    } else {
                        if (!flag && !_this.state[typeAdditionalField.slug]) {
                            flag = true;
                        }
                    }
                });

                // отдельно валидируем ИНН даже если это не обязательное поле
                // получаем поле ИНН
                var innField = setting.additionalFieldSettings.filter(function (fieldItem) {
                    return fieldItem.show_in_registration && fieldItem.typeAdditionalField && fieldItem.typeAdditionalField.slug === 'inn';
                })[0];
                // если есть поле ИНН
                if (innField) {
                    if (!flag && _this.state.inn && !_this.checkInn(innField.typeAdditionalField)) {
                        flag = true;
                    }
                }

                return !flag;
            }

            return true;
        };

        _this.isMinValid = function () {
            return _this.checkCustomField() && _this.state.password.length > 0;
        };

        _this.onClickAuth = function (event) {
            _this.props.showModalAuth(_this.props.lang);
        };

        _this.onClickPassRecovery = function (event) {
            _this.props.resetStep();
            _this.props.sendPhoneToReducer(_this.state.phone);
            _this.props.showModalPassRecovery(_this.props.lang);
        };

        _this.onSuccessCaptcha = function (value) {
            _this.setState({ captcha: value });
        };

        _this.showCaptcha = function () {
            if (_this.props.googleCaptcha) {
                setTimeout(function () {
                    grecaptcha.execute(_this.props.googleCaptchaSitekey, { action: 'submit' }).then(_this.onSuccessCaptcha);
                }, 500);
                // return (
                //     <Recaptcha
                //         sitekey={this.props.googleCaptchaSitekey}
                //         render="explicit"
                //         onChange={this.onSuccessCaptcha}
                //     />
                // );
            }

            return '';
        };

        _this.state = {
            password: '',
            errorsList: null,
            errorCode: null,
            captcha: null
        };

        _this.init = (0, _extends3.default)({}, _this.state);
        return _this;
    }

    (0, _createClass3.default)(RegistrationForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.resetError();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetError();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.errorsList) {// при возникновении ошибки
                // this.setState((prevState) => {
                //     return { // сбрасываем состояние
                //         ...prevState,
                //         email: '',
                //         inn: '',
                //         ul_name: '',
                //     };
                // });
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(event) {
            (0, _get3.default)(RegistrationForm.prototype.__proto__ || (0, _getPrototypeOf2.default)(RegistrationForm.prototype), 'onSubmit', this).call(this, event);

            if (this.isValid()) {
                if (this.props.googleCaptcha && this.state.captcha == null) {
                    var alertMessage = this.props.lang['user.errorInvalidCaptcha'];
                    setTimeout(function () {
                        _reactSAlert2.default.error(alertMessage, { position: 'top-right', effect: 'slide', timeout: 7000 });
                    }, 0);
                    return null;
                }
                var updateFormData = this.props.updateFormData;


                this.setState({
                    errorsList: '',
                    errorCode: null
                });

                var temp = (0, _extends3.default)({}, this.state);

                delete temp.errorsList;
                delete temp.errorCode;
                delete temp.password;
                if (temp.hasOwnProperty('phone') && temp.phone.length < 6) {
                    delete temp.phone;
                }

                // обновляем состояние родительского компонента
                updateFormData(temp);

                this.props.registration((0, _extends3.default)({
                    password: this.state.password,
                    shopId: this.props.shopId
                }, temp));
            }
        }
    }, {
        key: 'isValid',


        /**
         * Валидация по всем методам проверки
         * @returns {boolean}
         */
        value: function isValid() {
            var errorMessage = this.props.lang['store.password_recovery.pass_length_error'];
            if (!Validators.minLength(this.state.password, 6)) {
                this.setState({ errorsList: errorMessage, errorCode: 400 });
                return false;
            }

            return true;
        }

        /**
         * Валидация ИНН
         * @param typeAdditionalField
         * @returns {boolean}
         */


        /**
         * Dалидация настраиваемых полей
         * @returns {boolean}
         */


        /**
         * Обработчик активации кнопки "Зарегистрироваться"
         * @returns {boolean}
         */

    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('RegistrationForm', null, { folderName: 'Registration/RegistrationForm' });

            return _react2.default.createElement(View, {
                changeField: this.changeField,
                disabledSubmit: !this.isMinValid(),
                email: this.state.email,
                errorsList: this.state.errorsList || this.props.errorsList || '',
                errorCode: this.state.errorCode || this.props.errorCode,
                inn: this.state.inn,
                lang: this.props.lang,
                onClickAuth: this.onClickAuth,
                onClickPassRecovery: this.onClickPassRecovery,
                onSubmit: this.onSubmit,
                password: this.state.password,
                phone: this.state.phone,
                preload: this.props.preload,
                setting: this.props.setting,
                ul_name: this.state.ul_name,
                username: this.state.username,
                showCaptcha: this.showCaptcha
            });
        }
    }]);
    return RegistrationForm;
}(_BaseForm3.default), _class2.propTypes = {
    errorsList: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array]),
    lang: _react.PropTypes.object,
    onChange: _react.PropTypes.func,
    setting: _react.PropTypes.object.isRequired,
    showModalAuth: _react.PropTypes.func.isRequired,
    updateFormData: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = RegistrationForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/RegistrationForm/RegistrationForm.jsx
// module id = 1749
// module chunks = 0